import { createAction } from 'typesafe-actions';
import { SystemTransactionListResponse } from 'types/dto';
import { SortInfo } from 'types/sort';
import { PaginatedTransactionListRequestQuery } from 'types/transport';

export enum SystemTransactionAction {
  Clear = 'SYSTEM_TRANSACTION_CLEAR',
  Error = 'SYSTEM_TRANSACTION_ERROR',
  ListRequest = 'SYSTEM_TRANSACTION_LIST_REQUEST',
  ListResponse = 'SYSTEM_TRANSACTION_LIST_RESPONSE',
  Query = 'SYSTEM_TRANSACTION_QUERY',
  Select = 'SYSTEM_TRANSACTION_SELECT',
  Sort = 'SYSTEM_TRANSACTION_SORT',
}

export const systemTransactionClear = createAction(SystemTransactionAction.Clear)();
export const systemTransactionError = createAction(SystemTransactionAction.Error)<Error>();
export const systemTransactionListRequest = createAction(
  SystemTransactionAction.ListRequest,
)<PaginatedTransactionListRequestQuery>();
export const systemTransactionListResponse = createAction(
  SystemTransactionAction.ListResponse,
)<SystemTransactionListResponse>();
export const systemTransactionQuery = createAction(SystemTransactionAction.Query)<string>();
export const systemTransactionSelect = createAction(SystemTransactionAction.Select)<
  Array<string>
>();
export const systemTransactionSort = createAction(SystemTransactionAction.Sort)<SortInfo>();
